export const useAutoHeight = () => {
    function afterEnter(el: HTMLElement) {
        el.style.height = 'auto'
    }

    function enter(el: HTMLElement) {
        const height = getComputedStyle(el).height

        el.style.transition = 'opacity 0.2s 0.1s ease, height 0.2s ease'
        el.style.height = '0px'

        setTimeout(() => {
            el.style.height = height
        }, 5)
    }

    function leave(el: HTMLElement) {
        const height = getComputedStyle(el).height

        el.style.transition = 'opacity 0.2s ease, height 0.2s 0.1s ease'
        el.style.height = height

        setTimeout(() => {
            el.style.height = '0px'
        }, 5)
    }

    return {
        afterEnter,
        enter,
        leave,
    }
}
